( function($) {
	$( document ).ready( function() {
		$('article.talk').each( function() {
			let $this = $(this);
			let $entry_header = $this.find('.entry-header');
			let $talk_cta = $this.find('.entry-header .talk-cta');
			let height = $entry_header.outerHeight(true);
			$talk_cta.hide();
			$this.hover( function(){
				if ($(window).width() >= 520) {
					$entry_header.stop(true, false).animate({ height: '100%' }, 200, function() {
						$talk_cta.fadeIn(300);
					})
				}
			}, function(){
				if ($(window).width() >= 520) {
					$talk_cta.fadeOut();
					$entry_header.stop(true, false).animate({ height: height }, 200);
				}
			})
		})
	});
})(jQuery);
